export default {
  ArOwnerCode: "",
  Description: "",
  UserModified: localStorage.getItem("UserName"),
};
